module.exports = __webpack_public_path__ + "static/CCL logo-de61a552ef7b42dceb3529367fea4f57.jpg";